var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _ellipse, _path43, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path44, _path45, _path46, _ellipse8, _path47, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotSavedBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 175,
    viewBox: "0 0 228 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.123 144.888C123.77 144.888 139.215 133.028 139.215 111.732C139.215 111.732 133.986 104.586 113.123 104.586C92.2603 104.586 87.0312 111.732 87.0312 111.732C87.0312 133.028 102.477 144.888 113.123 144.888Z",
    fill: "url(#paint0_linear_1707_228899)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8882 111.767C89.8979 111.755 89.9112 111.738 89.9283 111.718C89.9704 111.667 90.0353 111.592 90.1257 111.496C90.3064 111.304 90.5889 111.027 90.9936 110.695C91.8028 110.031 93.1007 109.142 95.0503 108.253C98.9495 106.474 105.457 104.689 115.877 104.689C126.297 104.689 132.805 106.474 136.704 108.253C138.654 109.142 139.952 110.031 140.761 110.695C141.165 111.027 141.448 111.304 141.629 111.496C141.719 111.592 141.784 111.667 141.826 111.718C141.843 111.738 141.856 111.755 141.866 111.767C141.849 132.992 126.453 144.785 115.877 144.785C105.301 144.785 89.9052 132.992 89.8882 111.767Z",
    fill: "url(#paint1_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.328 143.829C100.714 140.656 90.0927 129.676 89.8911 112.238C91.5191 115.782 94.7325 117.866 97.9884 119.555C98.7446 119.947 99.5045 120.319 100.248 120.683C100.34 120.728 100.431 120.772 100.523 120.817C101.353 121.224 102.16 121.622 102.918 122.032C104.435 122.852 105.746 123.712 106.648 124.76C110.642 129.397 111.551 134.186 111.464 137.817C111.42 139.633 111.126 141.159 110.844 142.231C110.703 142.767 110.564 143.189 110.462 143.477C110.41 143.62 110.368 143.731 110.338 143.805C110.335 143.813 110.331 143.822 110.328 143.829Z",
    fill: "url(#paint2_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.426 143.829C131.04 140.656 141.661 129.676 141.863 112.238C140.235 115.782 137.021 117.866 133.765 119.555C133.009 119.947 132.249 120.319 131.506 120.683C131.414 120.728 131.323 120.772 131.231 120.817C130.401 121.224 129.594 121.622 128.836 122.032C127.319 122.852 126.008 123.712 125.106 124.76C121.112 129.397 120.202 134.186 120.29 137.817C120.334 139.633 120.628 141.159 120.91 142.231C121.051 142.767 121.19 143.189 121.292 143.477C121.344 143.62 121.386 143.731 121.416 143.805C121.419 143.813 121.423 143.822 121.426 143.829Z",
    fill: "url(#paint3_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8965 111.767C89.9061 111.754 89.9193 111.738 89.9361 111.718C89.9782 111.667 90.0431 111.592 90.1334 111.496C90.3141 111.304 90.5966 111.027 91.0011 110.695C91.8101 110.031 93.1078 109.142 95.057 108.253C98.9552 106.474 105.462 104.689 115.879 104.689C126.297 104.689 132.803 106.474 136.701 108.253C138.65 109.142 139.948 110.031 140.757 110.695C141.162 111.027 141.444 111.304 141.625 111.496C141.715 111.592 141.78 111.667 141.822 111.718C141.839 111.738 141.852 111.754 141.862 111.767C141.85 112.22 141.605 112.67 141.145 113.114C140.673 113.568 139.983 114.006 139.119 114.423C137.392 115.256 134.99 115.994 132.299 116.606C126.918 117.831 120.404 118.553 115.879 118.553C111.354 118.553 104.84 117.831 99.4591 116.606C96.7679 115.993 94.3658 115.256 92.6388 114.423C91.7749 114.006 91.0855 113.568 90.6135 113.114C90.1529 112.67 89.9083 112.22 89.8965 111.767Z",
    fill: "url(#paint4_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.958 112.483C125.474 112.483 135.002 110.031 135.002 107.61C135.002 107.61 128.114 104.73 115.958 104.73C103.802 104.73 97.3242 107.397 97.3242 107.397C97.3242 109.818 106.442 112.483 115.958 112.483Z",
    fill: "#667FE1",
    fillOpacity: 0.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.844 118.373C124.791 118.373 141.587 115.602 141.587 111.732C141.587 111.732 141.087 116.74 115.844 116.74C90.6014 116.74 90.1016 111.732 90.1016 111.732C90.1016 115.601 106.897 118.373 115.844 118.373Z",
    fill: "url(#paint5_linear_1707_228899)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.848 121.077C122.355 121.218 120.161 120.691 120.08 119.831C120.08 119.831 120.758 119.272 123.651 118.998C126.544 118.725 127.316 119.146 127.316 119.146C127.394 119.977 125.341 120.936 123.848 121.077Z",
    fill: "url(#paint6_linear_1707_228899)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.831 134.096C132.507 132.011 135.394 129.448 135.621 129.631C135.848 129.813 134.11 132.892 132.143 135.267C130.176 137.642 127.723 139.811 127.558 139.679C127.393 139.546 129.156 136.181 130.831 134.096Z",
    fill: "url(#paint7_linear_1707_228899)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3429 53.498C85.6873 47.9886 80.9825 42.293 73.712 42.293C65.5145 42.293 64.6664 53.4198 65.2672 59.7853C63.3913 60.7933 62.6523 61.4843 62.6523 61.4843C62.6523 89.5996 88.3801 106.648 112.999 106.648C137.618 106.648 163.345 89.5996 163.345 61.4843C163.345 61.4843 162.609 60.7959 160.741 59.7911C161.324 53.4103 160.444 42.3954 152.288 42.3954C145.059 42.3954 140.367 48.0251 137.703 53.5044C131.122 52.6307 122.989 52.0497 112.999 52.0497C103.033 52.0497 94.9158 52.6279 88.3429 53.498Z",
    fill: "url(#paint8_linear_1707_228899)",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.246 61.9936H137.984C138.303 59.4646 139.707 54.638 142.453 50.4189C145.241 46.1354 149.396 42.4976 155.183 42.4976C157.469 42.4976 159.171 43.3729 160.428 44.7702C161.688 46.1708 162.504 48.1006 163.004 50.2113C163.993 54.39 163.731 59.2433 163.246 61.9936Z",
    fill: "url(#paint9_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.168 61.5543C162.006 56.6199 158.256 52.2461 150.449 52.2461C146.617 52.2461 143.262 52.9567 140.352 54.1187V61.5543H163.168Z",
    fill: "url(#paint10_linear_1707_228899)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5432 61.8921H93.8056C93.4866 59.3631 92.0816 54.5365 89.3361 50.3174C86.5486 46.0339 82.3931 42.396 76.6062 42.396C74.3201 42.396 72.6181 43.2713 71.3612 44.6686C70.1012 46.0692 69.2847 47.999 68.7852 50.1097C67.7964 54.2884 68.0582 59.1417 68.5432 61.8921Z",
    fill: "url(#paint11_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5041 61.4527C69.6657 56.5183 73.4157 52.1445 81.223 52.1445C85.0551 52.1445 88.4096 52.8551 91.3203 54.0171V61.4527H68.5041Z",
    fill: "url(#paint12_linear_1707_228899)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.65 61.5295C65.6695 61.5125 65.6979 61.4881 65.7356 61.457C65.8177 61.3892 65.9441 61.2891 66.1197 61.1614C66.4709 60.9058 67.0188 60.5395 67.8029 60.0991C69.371 59.2185 71.8835 58.0419 75.6546 56.8645C83.1969 54.5097 95.7727 52.1519 115.893 52.1519C136.014 52.1519 148.59 54.5097 156.132 56.8645C159.903 58.0419 162.416 59.2185 163.984 60.0991C164.768 60.5395 165.316 60.9058 165.667 61.1614C165.843 61.2891 165.969 61.3892 166.051 61.457C166.089 61.4881 166.117 61.5125 166.137 61.5295C166.109 89.5421 140.462 106.544 115.893 106.544C91.3247 106.544 65.6781 89.5421 65.65 61.5295Z",
    fill: "url(#paint13_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.241 61.4832C166.241 61.4832 164.75 60.5284 163.556 59.8145C164.161 70.7626 160.869 90.2409 136.156 102.804C152.856 96.2842 166.241 81.7626 166.241 61.4832Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4909 53.9982C88.5356 53.9852 88.6007 53.967 88.6884 53.9442C88.88 53.8945 89.1792 53.8232 89.6075 53.7374C90.4642 53.5658 91.8369 53.3365 93.8971 53.1071C98.0176 52.6483 104.886 52.189 115.874 52.189C126.862 52.189 133.733 52.6482 137.856 53.107C139.918 53.3363 141.292 53.5656 142.15 53.7371C142.578 53.8229 142.878 53.8942 143.07 53.944C143.158 53.9668 143.223 53.9851 143.268 53.9981C143.24 54.2307 143.079 54.4951 142.766 54.7846C142.421 55.1033 141.907 55.438 141.233 55.7775C139.887 56.4561 137.924 57.1447 135.468 57.7612C130.558 58.9938 123.691 59.9341 115.874 59.9341C108.057 59.9341 101.193 58.9703 96.2854 57.726C93.8309 57.1037 91.8694 56.4121 90.5239 55.7378C89.8506 55.4005 89.3361 55.0696 88.9915 54.7572C88.6794 54.4742 88.5204 54.219 88.4909 53.9982Z",
    fill: "url(#paint14_linear_1707_228899)",
    stroke: "#A2A5D5",
    strokeWidth: 0.20614
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4798 54.5586C70.8376 57.3135 66.1875 61.6919 66.1875 61.6919C66.1875 83.2244 81.3574 98.186 99.4299 103.824C92.625 94.9891 80.508 72.7678 86.4798 54.5586Z",
    fill: "url(#paint15_linear_1707_228899)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.896 102.248C134.09 102.248 150.658 93.1577 153.978 77.4001C154.763 73.6731 152.962 70.0239 149.445 68.5609C144.119 66.3449 133.96 63.6816 115.896 63.6816C97.8319 63.6816 87.6731 66.3449 82.3469 68.5609C78.8303 70.0239 77.027 73.674 77.8236 77.3986C81.1664 93.0267 97.7196 102.248 115.896 102.248Z",
    fill: "url(#paint16_linear_1707_228899)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.501 69.66C141.318 67.6533 131.708 65.332 114.981 65.332C101.016 65.332 92.0112 66.9502 86.4023 68.6525C91.518 67.9566 103.012 68.005 105.997 75.7821C113.137 94.3857 125.41 97.2404 130.532 97.2404C133.595 97.2404 136.27 95.7309 136.53 95.5799C143.306 91.5401 148.921 85.7136 150.982 78.5383C152.055 74.7997 150.128 71.0644 146.501 69.66Z",
    fill: "url(#paint17_linear_1707_228899)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.893 67.7239C113.52 67.7239 110.142 67.0855 110.142 66.3318C110.142 66.3318 111.295 65.9023 115.893 65.9023C120.492 65.9023 121.645 66.3318 121.645 66.3318C121.645 67.06 118.267 67.7239 115.893 67.7239Z",
    fill: "url(#paint18_linear_1707_228899)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M158.404 69.5568C158.877 66.9242 160.782 63.3992 161.338 63.4992C161.894 63.5991 161.86 66.9146 161.228 69.9339C160.596 72.9533 159.152 76.2868 158.748 76.2143C158.345 76.1419 157.931 72.1894 158.404 69.5568Z",
    fill: "url(#paint19_linear_1707_228899)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0196 74.085C73.8615 76.6238 73.8717 80.6306 73.3352 80.8085C72.7988 80.9864 71.2453 78.0573 70.3582 75.1028C69.4711 72.1483 69.1478 68.5297 69.5366 68.4008C69.9255 68.2718 72.1777 71.5462 73.0196 74.085Z",
    fill: "url(#paint20_linear_1707_228899)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9317 83.675C76.5232 84.7218 76.6016 86.6428 76.2568 86.8376C75.9121 87.0325 74.852 85.9436 74.2237 84.7066C73.5954 83.4696 73.3208 81.7987 73.5707 81.6575C73.8206 81.5163 75.3401 82.6283 75.9317 83.675Z",
    fill: "url(#paint21_linear_1707_228899)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.875 53.5661C124.284 53.5661 130.653 53.0355 130.653 52.7044C130.653 52.7044 127.686 52.2871 115.875 52.2871C104.063 52.2871 101.102 52.7045 101.102 52.7045C101.102 53.0222 107.465 53.5661 115.875 53.5661Z",
    fill: "url(#paint22_linear_1707_228899)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.339 80.2812C108.374 80.6026 108.397 80.928 108.409 81.2569L107.636 81.2842C107.642 81.4375 107.644 81.5915 107.644 81.7464C107.644 81.9013 107.642 82.0554 107.636 82.2086L108.409 82.236C108.397 82.5648 108.374 82.8902 108.339 83.2116L107.571 83.1291C107.538 83.4372 107.494 83.7413 107.439 84.0408L108.2 84.1789C108.141 84.5024 108.071 84.8211 107.99 85.1344L107.241 84.9406C107.164 85.2399 107.076 85.5338 106.978 85.8218L107.709 86.0713C107.603 86.382 107.486 86.6864 107.359 86.9839L106.648 86.6792C106.527 86.9625 106.395 87.2388 106.254 87.5077L106.938 87.8669C106.786 88.1576 106.623 88.4403 106.45 88.7142L105.796 88.3014C105.632 88.5611 105.459 88.8121 105.277 89.0539L105.894 89.5189C105.697 89.7809 105.49 90.033 105.274 90.2744L104.698 89.7587C104.494 89.9862 104.282 90.2033 104.062 90.4093L104.59 90.9735C104.351 91.1975 104.103 91.4096 103.847 91.609L103.372 90.999C103.133 91.1854 102.886 91.3595 102.633 91.5207L103.048 92.1728C102.772 92.3483 102.489 92.51 102.199 92.6571L101.849 91.9675C101.581 92.1033 101.307 92.2254 101.028 92.333L101.305 93.0544C101.002 93.1714 100.692 93.2728 100.376 93.358L100.175 92.6117C99.8873 92.6893 99.595 92.7521 99.2985 92.7994L99.4203 93.5628C99.1005 93.6138 98.7761 93.6483 98.4478 93.6656L98.4073 92.8936C98.2587 92.9014 98.1091 92.9053 97.9587 92.9053C97.8083 92.9053 97.6587 92.9014 97.5101 92.8936L97.4696 93.6656C97.1413 93.6483 96.8169 93.6138 96.4971 93.5628L96.6189 92.7994C96.3224 92.7521 96.0301 92.6893 95.7427 92.6117L95.5412 93.358C95.2257 93.2728 94.9157 93.1714 94.6119 93.0544L94.8897 92.333C94.6102 92.2254 94.336 92.1033 94.068 91.9675L93.7187 92.6571C93.4284 92.51 93.145 92.3483 92.8693 92.1728L93.2845 91.5207C93.0312 91.3595 92.7846 91.1854 92.5453 90.999L92.0704 91.609C91.8142 91.4096 91.5662 91.1975 91.3271 90.9735L91.8555 90.4093C91.6356 90.2033 91.4234 89.9862 91.2196 89.7587L90.6438 90.2744C90.4275 90.033 90.2204 89.7809 90.0231 89.5189L90.6406 89.0539C90.4585 88.8121 90.2851 88.5611 90.1211 88.3014L89.4676 88.7142C89.2945 88.4403 89.1315 88.1576 88.9789 87.8669L89.6634 87.5077C89.5223 87.2388 89.3907 86.9625 89.2692 86.6792L88.5588 86.9839C88.4312 86.6864 88.3142 86.382 88.2082 86.0713L88.9398 85.8218C88.8416 85.5338 88.7535 85.2399 88.6759 84.9406L87.9276 85.1344C87.8464 84.8211 87.7762 84.5024 87.7175 84.1789L88.4781 84.0408C88.4237 83.7413 88.3797 83.4372 88.3467 83.1291L87.5781 83.2116C87.5436 82.8902 87.5203 82.5648 87.5086 82.236L88.2812 82.2086C88.2758 82.0554 88.273 81.9013 88.273 81.7464C88.273 81.5915 88.2758 81.4375 88.2812 81.2842L87.5086 81.2569C87.5203 80.928 87.5436 80.6026 87.5781 80.2812L88.3467 80.3637C88.3797 80.0556 88.4237 79.7515 88.4781 79.452L87.7175 79.3139C87.7762 78.9904 87.8464 78.6717 87.9276 78.3584L88.6759 78.5523C88.7535 78.253 88.8416 77.959 88.9398 77.671L88.2082 77.4215C88.3142 77.1108 88.4312 76.8064 88.5588 76.509L89.2692 76.8137C89.3907 76.5304 89.5223 76.254 89.6634 75.9851L88.9789 75.6259C89.1315 75.3352 89.2945 75.0526 89.4676 74.7786L90.1211 75.1914C90.2851 74.9318 90.4585 74.6807 90.6406 74.439L90.0231 73.9739C90.2204 73.7119 90.4275 73.4599 90.6438 73.2184L91.2196 73.7341C91.4234 73.5066 91.6356 73.2895 91.8555 73.0835L91.3271 72.5193C91.5662 72.2953 91.8142 72.0833 92.0704 71.8838L92.5453 72.4938C92.7846 72.3075 93.0312 72.1333 93.2845 71.9721L92.8693 71.32C93.145 71.1445 93.4284 70.9828 93.7187 70.8357L94.068 71.5253C94.336 71.3895 94.6102 71.2675 94.8897 71.1598L94.6119 70.4384C94.9157 70.3215 95.2257 70.22 95.5412 70.1348L95.7427 70.8811C96.0301 70.8035 96.3224 70.7407 96.6189 70.6934L96.4971 69.93C96.8169 69.879 97.1413 69.8445 97.4696 69.8273L97.5101 70.5992C97.6587 70.5914 97.8083 70.5875 97.9587 70.5875C98.1091 70.5875 98.2587 70.5914 98.4073 70.5992L98.4478 69.8273C98.7761 69.8445 99.1005 69.879 99.4203 69.93L99.2985 70.6934C99.595 70.7407 99.8873 70.8035 100.175 70.8811L100.376 70.1348C100.692 70.22 101.002 70.3215 101.305 70.4384L101.028 71.1598C101.307 71.2675 101.581 71.3895 101.849 71.5253L102.199 70.8357C102.489 70.9828 102.772 71.1445 103.048 71.32L102.633 71.9721C102.886 72.1333 103.133 72.3075 103.372 72.4938L103.847 71.8838C104.103 72.0833 104.351 72.2953 104.59 72.5193L104.062 73.0835C104.282 73.2895 104.494 73.5066 104.698 73.7341L105.274 73.2184C105.49 73.4599 105.697 73.7119 105.894 73.9739L105.277 74.439C105.459 74.6807 105.632 74.9318 105.796 75.1914L106.45 74.7786C106.623 75.0526 106.786 75.3352 106.938 75.6259L106.254 75.9851C106.395 76.254 106.527 76.5304 106.648 76.8137L107.359 76.509C107.486 76.8064 107.603 77.1108 107.709 77.4215L106.978 77.671C107.076 77.959 107.164 78.253 107.241 78.5523L107.99 78.3584C108.071 78.6717 108.141 78.9904 108.2 79.3139L107.439 79.452C107.494 79.7515 107.538 80.0556 107.571 80.3637L108.339 80.2812Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.54605,
    strokeDasharray: "1.03 1.03"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.183 80.2812C144.218 80.6026 144.241 80.928 144.253 81.2569L143.48 81.2842C143.485 81.4375 143.488 81.5915 143.488 81.7464C143.488 81.9013 143.485 82.0554 143.48 82.2086L144.253 82.236C144.241 82.5648 144.218 82.8902 144.183 83.2116L143.414 83.1291C143.381 83.4372 143.337 83.7413 143.283 84.0408L144.044 84.1789C143.985 84.5024 143.915 84.8211 143.834 85.1344L143.085 84.9406C143.008 85.2399 142.92 85.5338 142.821 85.8218L143.553 86.0713C143.447 86.382 143.33 86.6864 143.202 86.9839L142.492 86.6792C142.37 86.9625 142.239 87.2388 142.098 87.5077L142.782 87.8669C142.63 88.1576 142.467 88.4403 142.294 88.7142L141.64 88.3014C141.476 88.5611 141.303 88.8121 141.121 89.0539L141.738 89.5189C141.541 89.7809 141.334 90.033 141.117 90.2744L140.542 89.7587C140.338 89.9862 140.126 90.2033 139.906 90.4093L140.434 90.9735C140.195 91.1975 139.947 91.4096 139.691 91.609L139.216 90.999C138.977 91.1854 138.73 91.3595 138.477 91.5207L138.892 92.1728C138.616 92.3483 138.333 92.51 138.042 92.6571L137.693 91.9675C137.425 92.1033 137.151 92.2254 136.871 92.333L137.149 93.0544C136.845 93.1714 136.535 93.2728 136.22 93.358L136.018 92.6117C135.731 92.6893 135.439 92.7521 135.142 92.7994L135.264 93.5628C134.944 93.6138 134.62 93.6483 134.292 93.6656L134.251 92.8936C134.102 92.9014 133.953 92.9053 133.802 92.9053C133.652 92.9053 133.502 92.9014 133.354 92.8936L133.313 93.6656C132.985 93.6483 132.661 93.6138 132.341 93.5628L132.463 92.7994C132.166 92.7521 131.874 92.6893 131.586 92.6117L131.385 93.358C131.069 93.2728 130.759 93.1714 130.456 93.0544L130.733 92.333C130.454 92.2254 130.18 92.1033 129.912 91.9675L129.562 92.6571C129.272 92.51 128.989 92.3483 128.713 92.1728L129.128 91.5207C128.875 91.3595 128.628 91.1854 128.389 90.999L127.914 91.609C127.658 91.4096 127.41 91.1975 127.171 90.9735L127.699 90.4093C127.479 90.2033 127.267 89.9862 127.063 89.7587L126.488 90.2744C126.271 90.033 126.064 89.7809 125.867 89.5189L126.484 89.0539C126.302 88.8121 126.129 88.5611 125.965 88.3014L125.311 88.7142C125.138 88.4403 124.975 88.1576 124.823 87.8669L125.507 87.5077C125.366 87.2388 125.234 86.9625 125.113 86.6792L124.403 86.9839C124.275 86.6864 124.158 86.382 124.052 86.0713L124.784 85.8218C124.685 85.5338 124.597 85.2399 124.52 84.9406L123.771 85.1344C123.69 84.8211 123.62 84.5024 123.561 84.1789L124.322 84.0408C124.267 83.7413 124.223 83.4372 124.19 83.1291L123.422 83.2116C123.387 82.8902 123.364 82.5648 123.352 82.236L124.125 82.2086C124.12 82.0554 124.117 81.9013 124.117 81.7464C124.117 81.5915 124.12 81.4375 124.125 81.2842L123.352 81.2569C123.364 80.928 123.387 80.6026 123.422 80.2812L124.19 80.3637C124.223 80.0556 124.267 79.7515 124.322 79.452L123.561 79.3139C123.62 78.9904 123.69 78.6717 123.771 78.3584L124.52 78.5523C124.597 78.253 124.685 77.959 124.784 77.671L124.052 77.4215C124.158 77.1108 124.275 76.8064 124.403 76.509L125.113 76.8137C125.234 76.5304 125.366 76.254 125.507 75.9851L124.823 75.6259C124.975 75.3352 125.138 75.0526 125.311 74.7786L125.965 75.1914C126.129 74.9318 126.302 74.6807 126.484 74.439L125.867 73.9739C126.064 73.7119 126.271 73.4599 126.488 73.2184L127.063 73.7341C127.267 73.5066 127.479 73.2895 127.699 73.0835L127.171 72.5193C127.41 72.2953 127.658 72.0833 127.914 71.8838L128.389 72.4938C128.628 72.3075 128.875 72.1333 129.128 71.9721L128.713 71.32C128.989 71.1445 129.272 70.9828 129.562 70.8357L129.912 71.5253C130.18 71.3895 130.454 71.2675 130.733 71.1598L130.456 70.4384C130.759 70.3215 131.069 70.22 131.385 70.1348L131.586 70.8811C131.874 70.8035 132.166 70.7407 132.463 70.6934L132.341 69.93C132.661 69.879 132.985 69.8445 133.313 69.8273L133.354 70.5992C133.502 70.5914 133.652 70.5875 133.802 70.5875C133.953 70.5875 134.102 70.5914 134.251 70.5992L134.292 69.8273C134.62 69.8445 134.944 69.879 135.264 69.93L135.142 70.6934C135.439 70.7407 135.731 70.8035 136.018 70.8811L136.22 70.1348C136.535 70.22 136.845 70.3215 137.149 70.4384L136.871 71.1598C137.151 71.2675 137.425 71.3895 137.693 71.5253L138.042 70.8357C138.333 70.9828 138.616 71.1445 138.892 71.32L138.477 71.9721C138.73 72.1333 138.977 72.3075 139.216 72.4938L139.691 71.8838C139.947 72.0833 140.195 72.2953 140.434 72.5193L139.906 73.0835C140.126 73.2895 140.338 73.5066 140.542 73.7341L141.117 73.2184C141.334 73.4599 141.541 73.7119 141.738 73.9739L141.121 74.439C141.303 74.6807 141.476 74.9318 141.64 75.1914L142.294 74.7786C142.467 75.0526 142.63 75.3352 142.782 75.6259L142.098 75.9851C142.239 76.254 142.37 76.5304 142.492 76.8137L143.202 76.509C143.33 76.8064 143.447 77.1108 143.553 77.4215L142.821 77.671C142.92 77.959 143.008 78.253 143.085 78.5523L143.834 78.3584C143.915 78.6717 143.985 78.9904 144.044 79.3139L143.283 79.452C143.337 79.7515 143.381 80.0556 143.414 80.3637L144.183 80.2812Z",
    stroke: "#8FDBFF",
    strokeWidth: 1.54605,
    strokeDasharray: "1.03 1.03"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.731 112.854C141.731 112.854 140.642 114.792 139.577 115.775C140.038 123.304 133.468 140.798 117.977 144.518C131.556 142.136 141.328 129.175 141.731 112.854Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9763 119.17C94.4048 121.964 92.7215 123.863 91.9664 123.644C91.2114 123.425 90.9549 122.964 90.4563 119.711C89.9577 116.459 89.9029 116.028 90.7193 115.508C91.5357 114.987 93.5478 116.375 93.9763 119.17Z",
    fill: "url(#paint23_linear_1707_228899)",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9597 121.484C96.4424 127.028 95.9311 131.535 95.1875 130.91C94.4438 130.284 91.7084 124.431 90.8496 120.918C89.9908 117.406 89.8891 116.156 90.6972 115.528C91.5054 114.899 93.477 115.939 94.9597 121.484Z",
    fill: "url(#paint24_linear_1707_228899)",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M137.582 119.238C137.154 122.032 138.837 123.931 139.592 123.712C140.347 123.493 140.604 123.033 141.102 119.78C141.601 116.527 141.656 116.096 140.839 115.576C140.023 115.055 138.011 116.444 137.582 119.238Z",
    fill: "url(#paint25_linear_1707_228899)",
    fillOpacity: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M136.599 121.55C135.116 127.095 135.627 131.602 136.371 130.976C137.115 130.351 139.85 124.498 140.709 120.985C141.568 117.472 141.67 116.223 140.861 115.594C140.053 114.966 138.082 116.005 136.599 121.55Z",
    fill: "url(#paint26_linear_1707_228899)",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M170.763 109.57C160.716 118.433 144.115 125.231 141.813 122.623C139.512 120.014 150.577 107.083 160.73 98.6286C170.883 90.1738 181.17 80.8227 184.332 84.4073C187.493 87.9918 180.809 100.707 170.763 109.57Z",
    fill: "url(#paint27_linear_1707_228899)",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M167.907 108.384C157.861 117.247 141.259 124.045 138.958 121.437C136.657 118.829 147.722 105.898 157.875 97.443C168.027 88.9882 178.315 79.6372 181.476 83.2217C184.638 86.8062 177.953 99.521 167.907 108.384Z",
    fill: "url(#paint28_linear_1707_228899)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M157.635 97.3134C167.725 88.849 177.998 79.5461 180.752 82.6687C180.752 82.6687 178.03 80.8284 158.785 97.7167C136.561 117.219 138.75 120.683 138.75 120.683C136.745 118.411 147.544 105.778 157.635 97.3134Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M167.906 108.385C177.952 99.5216 184.637 86.8068 181.475 83.2223C180.997 82.68 180.356 82.4338 179.576 82.4357C179.576 82.4357 177.64 88.4986 170.538 99.0118C160.898 113.282 155.322 116.863 154.123 117.516C154.041 117.558 153.96 117.599 153.878 117.64C153.878 117.64 153.96 117.606 154.123 117.516C158.88 115.107 163.911 111.909 167.906 108.385Z",
    fill: "url(#paint29_linear_1707_228899)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.311 98.7947C160.01 100.886 155.998 103.048 155.665 102.681C155.331 102.314 157.816 99.3998 160.52 97.0464C163.223 94.693 166.756 92.4688 166.998 92.7349C167.239 93.0009 164.611 96.7037 162.311 98.7947Z",
    fill: "url(#paint30_linear_1707_228899)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3078 109.57C70.3539 118.433 86.9557 125.231 89.2569 122.623C91.5582 120.014 80.4929 107.083 70.3401 98.6286C60.1873 90.1738 49.8999 80.8227 46.7384 84.4073C43.5769 87.9918 50.2616 100.707 60.3078 109.57Z",
    fill: "url(#paint31_linear_1707_228899)",
    fillOpacity: 0.3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1632 108.384C73.2093 117.247 89.8111 124.045 92.1124 121.437C94.4137 118.829 83.3483 105.898 73.1956 97.443C63.0428 88.9882 52.7554 79.6372 49.5939 83.2217C46.4323 86.8062 53.1171 99.521 63.1632 108.384Z",
    fill: "url(#paint32_linear_1707_228899)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4356 97.3134C63.3454 88.849 53.0723 79.5461 50.3183 82.6687C50.3183 82.6687 53.0398 80.8284 72.2855 97.7167C94.5096 117.219 92.3204 120.683 92.3204 120.683C94.3251 118.411 83.5259 105.778 73.4356 97.3134Z",
    fill: "#D185F2",
    fillOpacity: 0.3
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1644 108.385C53.1183 99.5216 46.4335 86.8068 49.5951 83.2223C50.0733 82.68 50.7147 82.4338 51.494 82.4357C51.494 82.4357 53.4302 88.4986 60.5322 99.0118C70.1724 113.282 75.7481 116.863 76.947 117.516C77.0289 117.558 77.1108 117.599 77.1925 117.64C77.1925 117.64 77.1104 117.606 76.947 117.516C72.1905 115.107 67.1592 111.909 63.1644 108.385Z",
    fill: "url(#paint33_linear_1707_228899)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7598 98.7947C71.0599 100.886 75.0721 103.048 75.4057 102.681C75.7394 102.314 73.2542 99.3998 70.5506 97.0464C67.847 94.693 64.3146 92.4688 64.0727 92.7349C63.8309 93.0009 66.4596 96.7037 68.7598 98.7947Z",
    fill: "url(#paint34_linear_1707_228899)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.608,
    cy: 162.408,
    rx: 31.6588,
    ry: 11.408,
    fill: "url(#paint35_radial_1707_228899)",
    fillOpacity: 0.4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.895 29.373L115.895 51.7933",
    stroke: "url(#paint36_linear_1707_228899)",
    strokeWidth: 1.30481,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.718,
    cy: 28.5668,
    rx: 4.7184,
    ry: 4.56684,
    fill: "url(#paint37_linear_1707_228899)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 29,
    rx: 9.5,
    ry: 9,
    stroke: "url(#paint38_linear_1707_228899)",
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 29,
    rx: 13.5,
    ry: 13,
    stroke: "url(#paint39_linear_1707_228899)",
    strokeOpacity: 0.8,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 29,
    rx: 17.5,
    ry: 17,
    stroke: "url(#paint40_linear_1707_228899)",
    strokeOpacity: 0.6,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 29,
    rx: 21.5,
    ry: 21,
    stroke: "url(#paint41_linear_1707_228899)",
    strokeOpacity: 0.4,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 115.5,
    cy: 29,
    rx: 25.5,
    ry: 25,
    stroke: "url(#paint42_linear_1707_228899)",
    strokeOpacity: 0.2,
    strokeWidth: 1.54011,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M21.12 47.7906L29.7545 51.141C31.6444 44.5637 40.7659 45.9764 43.4556 39.0448C46.2798 31.7666 42.3349 26.9128 36.003 24.4558C31.3979 22.6689 26.5743 23.3227 22.4985 25.463L25.9819 32.5302C28.0164 31.7247 29.6863 31.1763 31.6434 31.9358C33.3703 32.6059 34.5532 33.9953 33.7463 36.0748C32.3118 39.7716 22.8826 39.8346 21.12 47.7906ZM19.6417 64.2309C22.9803 65.5264 26.429 63.8074 27.7291 60.4571C29.0291 57.1069 27.6425 53.5116 24.3038 52.2161C20.9652 50.9206 17.5164 52.6396 16.2164 55.9898C14.9164 59.3401 16.303 62.9354 19.6417 64.2309Z",
    fill: "#2F2DC1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M53.5308 157.947L58.8901 156.06C57.1116 152.149 61.9145 149.138 60.3641 144.735C58.7361 140.111 54.9459 139.383 51.0157 140.767C48.1574 141.773 46.1831 144.036 45.1559 146.707L49.6256 148.681C50.2445 147.473 50.7979 146.536 52.0127 146.108C53.0846 145.731 54.1944 145.917 54.6596 147.238C55.4865 149.587 51.1365 153.428 53.5308 157.947ZM59.4824 166.411C61.5547 165.681 62.461 163.465 61.7116 161.336C60.9622 159.208 58.8672 158.048 56.7949 158.778C54.7227 159.507 53.8164 161.724 54.5658 163.852C55.3152 165.981 57.4101 167.14 59.4824 166.411Z",
    fill: "#2F2DC1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M187.283 28.9402L191.354 27.507C190.003 24.5366 193.651 22.2497 192.473 18.905C191.237 15.3931 188.358 14.8403 185.373 15.8914C183.202 16.6557 181.703 18.3742 180.922 20.4032L184.317 21.9021C184.787 20.9847 185.208 20.2728 186.13 19.9479C186.945 19.6613 187.787 19.8031 188.141 20.8065C188.769 22.5903 185.465 25.5079 187.283 28.9402ZM191.804 35.3685C193.378 34.8143 194.066 33.1309 193.497 31.5143C192.928 29.8977 191.337 29.0169 189.763 29.571C188.189 30.1252 187.5 31.8086 188.07 33.4252C188.639 35.0418 190.23 35.9227 191.804 35.3685Z",
    fill: "#2F2DC1"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 95.5,
    rx: 3,
    ry: 4.5,
    fill: "url(#paint43_linear_1707_228899)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M206.41 105.413L216.105 103.571C214.127 96.6865 223.177 92.8556 221.725 85.2113C220.2 77.1848 213.907 75.08 206.798 76.4305C201.627 77.4127 197.627 80.6805 195.137 84.8494L202.254 89.1738C203.644 87.3257 204.848 85.909 207.045 85.4915C208.984 85.1232 210.834 85.6959 211.27 87.9892C212.044 92.0661 203.544 97.3768 206.41 105.413ZM214.29 120.812C218.039 120.1 220.197 116.654 219.495 112.959C218.793 109.264 215.522 106.85 211.773 107.562C208.024 108.274 205.866 111.72 206.568 115.415C207.27 119.109 210.541 121.524 214.29 120.812Z",
    fill: "#2F2DC1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1707_228899",
    x1: 139.215,
    y1: 122.515,
    x2: 83.2151,
    y2: 122.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1707_228899",
    x1: 89.7852,
    y1: 115.808,
    x2: 141.969,
    y2: 115.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1707_228899",
    x1: 89.7852,
    y1: 122.568,
    x2: 109.999,
    y2: 129.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1707_228899",
    x1: 141.969,
    y1: 122.568,
    x2: 121.755,
    y2: 129.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693995,
    stopColor: "#C3DFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1707_228899",
    x1: 89.793,
    y1: 115.808,
    x2: 141.965,
    y2: 115.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#E9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#E9E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1707_228899",
    x1: 115.212,
    y1: 116.164,
    x2: 115.138,
    y2: 118.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336756,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1707_228899",
    x1: 123.651,
    y1: 118.998,
    x2: 123.848,
    y2: 121.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#CCD7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1707_228899",
    x1: 131.786,
    y1: 134.863,
    x2: 130.85,
    y2: 134.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1707_228899",
    x1: 163.345,
    y1: 70.9225,
    x2: 55.2888,
    y2: 70.9225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1707_228899",
    x1: 148.181,
    y1: 67.7579,
    x2: 156.804,
    y2: 42.3945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1707_228899",
    x1: 165.628,
    y1: 61.5543,
    x2: 140.352,
    y2: 53.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1707_228899",
    x1: 83.6079,
    y1: 67.6563,
    x2: 74.9846,
    y2: 42.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821767,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1707_228899",
    x1: 66.0435,
    y1: 61.4527,
    x2: 91.3203,
    y2: 53.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369241,
    stopColor: "#C2DEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687753,
    stopColor: "#B4CDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1707_228899",
    x1: 65.5469,
    y1: 66.8639,
    x2: 166.24,
    y2: 66.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7EAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#D1D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#C0E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1707_228899",
    x1: 88.3843,
    y1: 54.8002,
    x2: 143.364,
    y2: 54.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.149193,
    stopColor: "#BCBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519605,
    stopColor: "#BBBAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87384,
    stopColor: "#97B1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91C5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1707_228899",
    x1: 72.2936,
    y1: 83.931,
    x2: 87.1282,
    y2: 76.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3DFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1707_228899",
    x1: 80.3509,
    y1: 84.3162,
    x2: 154.581,
    y2: 71.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.470359,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1707_228899",
    x1: 108.224,
    y1: 81.2862,
    x2: 151.57,
    y2: 71.7532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3134D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1707_228899",
    x1: 115.893,
    y1: 65.9023,
    x2: 115.893,
    y2: 67.7239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1707_228899",
    x1: 160.744,
    y1: 69.9772,
    x2: 158.535,
    y2: 69.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1707_228899",
    x1: 70.0835,
    y1: 74.8468,
    x2: 73.0267,
    y2: 73.8116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387196,
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1707_228899",
    x1: 74.4813,
    y1: 84.4948,
    x2: 75.6594,
    y2: 83.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1707_228899",
    x1: 116.472,
    y1: 53.5661,
    x2: 116.472,
    y2: 52.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458744,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1707_228899",
    x1: 90.4553,
    y1: 119.705,
    x2: 93.9756,
    y2: 119.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1707_228899",
    x1: 90.5967,
    y1: 120.848,
    x2: 94.1497,
    y2: 120.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1707_228899",
    x1: 141.103,
    y1: 119.773,
    x2: 137.583,
    y2: 119.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1707_228899",
    x1: 140.962,
    y1: 120.914,
    x2: 137.409,
    y2: 120.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1EA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E2DDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1707_228899",
    x1: 142.543,
    y1: 123.45,
    x2: 188.546,
    y2: 82.8645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1707_228899",
    x1: 139.178,
    y1: 120.731,
    x2: 179.994,
    y2: 82.2733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1707_228899",
    x1: 170.328,
    y1: 97.8926,
    x2: 174.885,
    y2: 100.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1707_228899",
    x1: 160.907,
    y1: 97.2506,
    x2: 162.34,
    y2: 98.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1707_228899",
    x1: 88.5272,
    y1: 123.45,
    x2: 42.5246,
    y2: 82.8645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DE0FF",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1707_228899",
    x1: 91.8922,
    y1: 120.731,
    x2: 51.0759,
    y2: 82.2733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295244,
    stopColor: "#E4E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593241,
    stopColor: "#DBDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1707_228899",
    x1: 60.7419,
    y1: 97.8926,
    x2: 56.1855,
    y2: 100.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1707_228899",
    x1: 70.1635,
    y1: 97.2506,
    x2: 68.7301,
    y2: 98.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1707_228899",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.608 162.408) rotate(90) scale(10.1211 28.0875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AE7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#9AE7FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1707_228899",
    x1: 116.395,
    y1: 29.373,
    x2: 116.395,
    y2: 51.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92E8FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#C1E1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1707_228899",
    x1: 115.718,
    y1: 24,
    x2: 115.718,
    y2: 33.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCECEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421216,
    stopColor: "#FFC8BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7155"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1707_228899",
    x1: 115.5,
    y1: 20,
    x2: 115.5,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1707_228899",
    x1: 115.5,
    y1: 16,
    x2: 115.5,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1707_228899",
    x1: 115.5,
    y1: 12,
    x2: 115.5,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1707_228899",
    x1: 115.5,
    y1: 8,
    x2: 115.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1707_228899",
    x1: 115.5,
    y1: 4,
    x2: 115.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E54322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509934,
    stopColor: "#F9674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1707_228899",
    x1: 116,
    y1: 91,
    x2: 116,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771045,
    stopColor: "#C7C5FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSavedBot);
export default __webpack_public_path__ + "static/media/not-saved-bot.7f3f7051147853b66942c557972e97fa.svg";
export { ForwardRef as ReactComponent };